"use strict";

exports.__esModule = true;
exports.ReportCollection = ReportCollection;
var _react = _interopRequireDefault(require("react"));
var _API = require("../../API");
var _DataAccessorContext = require("../../API/DataInterface/DataAccessorContext");
var _useAiDraftsStore = require("../../AI/Authoring/useAiDraftsStore");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Provides access to reports via a render prop.
 */
function ReportCollection(props) {
  var dataAccessor = _react["default"].useContext(_DataAccessorContext.DataAccessorContext);
  // AI-made reports live in the browser until the backend takes them.
  var localStore = (0, _useAiDraftsStore.useAiDraftsStore)("reports");
  return /*#__PURE__*/_react["default"].createElement(_API.Collection, {
    baseURL: "/api/v3/ui-config/reports",
    itemBaseURL: "/api/v3/ui-config/reports/:id",
    localStore: localStore,
    apiInterface: {
      getById: function getById(id) {
        return dataAccessor.getReportConfig(id);
      }
    }
  }, props.children);
}